import React from 'react';
import _ from 'lodash';
import UUID from '@ax2/common/model/UUID';
import styles from '../../../styles/components/answers/layouts/MobileGrid.module.css';
import {
  ParticipantDefinedFieldData,
  ParticipantDefinedField,
} from '../ParticipantDefinedOption';

export interface MobileGridOption {
  id: UUID;
  title: string;
}

export interface MobileGridData {
  primaryOptions: (MobileGridOption | ParticipantDefinedFieldData)[];
  secondaryRenderer: (
    primaryOptionId: UUID,
    primaryOptionIndex: number
  ) => JSX.Element;
}

export const MobileGrid: React.FC<MobileGridData> = ({
  primaryOptions,
  secondaryRenderer,
}) => {
  return (
    <div className={styles.mobileGrid}>
      {_.map(primaryOptions, (p, index) => (
        <div className={styles.mobileGridSection} key={`${p.id}-1`}>
          {'title' in p ? (
            <span className={styles.mobileTitle}>{p.title}</span>
          ) : (
            <ParticipantDefinedField {...p} />
          )}
          {secondaryRenderer(p.id, index)}
        </div>
      ))}
    </div>
  );
};
